module.exports = "/_next/static/images/fallback-image-1-1-129cf8c2c971c959c528b37739c1e113.png";